export default __webpack_public_path__ + "static/media/BOL.d62c8165.svg";